import { Input, message, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { updateFolder, folderList } from '../../../../services/file';
import { t } from '../../../../locales';

import './index.scss';
import useFolderStore from '../../../../stores/folderStore';

type Props = {
  folderId: number,
  folderName: string,
  onSuccess?: () => void,
  onCancel?: () => void,
}

// 更全面的版本（推荐）
function validateInput(value: string) {
    // 这个正则允许：字母、数字、汉字、空格、下划线、中划线
    // 不允许：特殊字符 / \ ' " < > ; : ! @ # $ % ^ & * ( ) = + [ ] { } | , . ? ` ~
    const regex = /^[a-zA-Z0-9\u4e00-\u9fa5\s\-_]+$/;
    return regex.test(value);
}

const EditFolder = (props: Props) => {
  const { folderId, folderName, onSuccess, onCancel } = props;
  const [editModalVisible, setEditModalVisible] = useState(true);
  const [newFolderName, setNewFolderName] = useState(folderName);
  const [editLoading, setEditLoading] = useState(false);
  const { setFolders } = useFolderStore.getState();
  const { folders } = useFolderStore();

  useEffect(() => {
    setNewFolderName(folderName);
  }, [folderName]);

  const handleEditCancel = () => {
    setEditModalVisible(false);
    setNewFolderName(folderName);
    onCancel?.();
  }

  const handleEditKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleEditSubmit();
    }
  }

  const handleEditSubmit = async () => {
    const val = newFolderName.trim()
    if (!val) {
      message.warning(t('file.addFolderPlaceholder'));
      return;
    }

    if (val === folderName) {
      message.warning(t('file.folderNameUnchanged'));
      return;
    }

    const folderNames = folders.filter(i => i.folderId !== folderId).map(i => i.folderName)
    if (folderNames.includes(val)) {
      message.warning(t('file.folderExists'));
      return;
    }

    if (!validateInput(val)) {
      message.warning(t('file.invalidCharacters'));
      return;
    }

    setEditLoading(true);
    try {
      // 调用更新接口
      await updateFolder(folderId, val);

      message.success(t('file.updateFolderSuccess'));
      setEditModalVisible(false);
      setNewFolderName('');

      // 调用成功回调
      onSuccess?.();
      const res = await folderList()
      setFolders(res.folders)

    } catch (error) {
      message.error(t('file.updateFolderFail'));
    } finally {
      setEditLoading(false);
    }
  }

  return (
    <Modal
      title={t('file.editFolder')}
      visible={editModalVisible}
      onCancel={handleEditCancel}
      onOk={handleEditSubmit}
      confirmLoading={editLoading}
      okText={t('common.save')}
      cancelText={t('common.cancel')}
      destroyOnClose
      maskClosable={false}
      width={460}
      className="rename-modal"
    >
      <div className="rename-input-container">
        <Input
          placeholder={t('file.addFolderPlaceholder')}
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
          onKeyDown={handleEditKeyPress}
          autoFocus
          maxLength={20}
          className="rename-input"
        />
      </div>
    </Modal>
  )

}

export default EditFolder;
